import { Skeleton } from "@/components/ui/skeleton";

export const ExpenseHistorySkeleton = () => {
  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-5 w-20" />
      </div>

      {/* Month Summary Skeleton */}
      <div className="bg-muted/30 rounded-xl p-4 space-y-3">
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-16" />
        </div>
        <Skeleton className="h-8 w-32" />
        <div className="flex gap-4">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-20" />
        </div>
      </div>

      {/* Date Group 1 - Today */}
      <div className="space-y-3">
        <div className="py-2">
          <Skeleton className="h-4 w-16" />
        </div>
        
        {/* Expense items */}
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex items-center justify-between p-5 bg-card border border-l-4 border-l-muted rounded-xl">
            <div className="flex-1 min-w-0 mr-4 space-y-2">
              <Skeleton className="h-5 w-32" />
              <div className="flex items-center gap-2">
                <Skeleton className="h-6 w-16 rounded-md" />
                <Skeleton className="h-4 w-24" />
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-6 w-20" />
              <Skeleton className="h-10 w-10 rounded-md" />
            </div>
          </div>
        ))}
      </div>

      {/* Date Group 2 - Yesterday */}
      <div className="space-y-3">
        <div className="py-2">
          <Skeleton className="h-4 w-20" />
        </div>
        
        {[1, 2].map((i) => (
          <div key={i} className="flex items-center justify-between p-5 bg-card border border-l-4 border-l-muted rounded-xl">
            <div className="flex-1 min-w-0 mr-4 space-y-2">
              <Skeleton className="h-5 w-28" />
              <div className="flex items-center gap-2">
                <Skeleton className="h-6 w-20 rounded-md" />
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-6 w-16" />
              <Skeleton className="h-10 w-10 rounded-md" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
